<template>
  <div>
    <section class="main-content">

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="bck-index bck-articles">
                            <h3 class="title sr-only"><span>About us</span></h3>
                            <div class="articles-items">
                                <div class="articles-box contact-box">
                                    <div class="row strict">
                                        <div class="col-md-5">
                                            <figure class="pic articles-pic mb-0 pic-left">
                                            <img class="img-fluid" src="/static/images/contact.jpg" />
                                        </figure>
                                        </div>
                                        <div class="col-md-7 text-bg">
                                            <div class="text">
                                                <h4 class="title text-primary">請填好以下的回覆表格<br />我們會盡快和你聯絡</h4>
                                                <form class="contact-form" action="" method="post">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label class="sr-only" for="name">Example label</label>
                                                                <input type="text" class="form-control form-control-sm" v-model="name" id="name" placeholder="姓名">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label class="sr-only" for="email">Another label</label>
                                                                <input type="text" class="form-control form-control-sm" v-model="email" id="email" placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label class="sr-only" for="mobile">Another label</label>
                                                                <input type="text" class="form-control form-control-sm" id="mobile" placeholder="手機">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label class="sr-only" for="message">Example textarea</label>
                                                                <textarea class="form-control form-control-sm" id="message" rows="4" placeholder="留言訊息/婚禮歌曲使用video上傳"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="button" @click="addContact" class="btn btn-primary btn-block">送出</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--
                                <div class="articles-box contact-box">
                                    <div class="row strict">
                                      <div class="col-md-5 push-md-7">
                                          <figure class="pic articles-pic mb-0 pic-right">
                                          <img class="img-fluid" src="/static/images/contact-1.png" />
                                      </figure>
                                      </div>
                                        <div class="col-md-7 pull-md-5 text-bg">
                                            <div class="text">
                                                <h4 class="title text-primary">TWILIGHT EVENTS</h4>
                                                <p class="txt">
                                                    500 Terry Francois Street,<br />
                                                    SF, CA 94158
                                                </p>
                                                <p class="txt">
                                                    Tel: 123-456-7890
                                                    Fax: 123-456-7890<br />
                                                    info@mysite.com
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                -->
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>


        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'contact',
  data () {
    return {
      uri: this.$store.getters.getUri,
      name: '',
      email: '',
      context: 'test'
    }
  },
  computed: {
    ...mapGetters([
      'getUri',
      'getTestUri'
    ])
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    addContact () {
      let str = ''
      // console.log(this.UserID)
      if (this.name === '') {
        str += '請填寫個人姓名。\n'
      } else if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的信箱\n'
      }
      if (str === '') {
        let data = Qs.stringify({
          name: this.name,
          email: this.email,
          context: this.context
        })
        this.$http.post(this.uri + 'Contact/add_contact', data)
        .then(function (res) {
          let data = res.data
          console.log(data)
          if (data.status === 200) {
            window.alert('我們已收到您的訊息，將盡快與您聯繫，謝謝')
          } else {
            window.alert('填寫失敗。')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        window.alert(str)
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Contact.vue?da81b6a4